import React from "react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const financialData = {
  badge: "FinTech AI",
  title: "Financial Services AI",
  industry: "Financial Services",
  tagline: "Scale customer service, reduce costs, and improve experiences with intelligent AI advisors.",
  image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&q=85&w=1200&h=800",
  cta: "Explore FinTech Platform",
  stats: [
    { number: "45%", label: "Support Cost Reduction" },
    { number: "2x", label: "Onboarding Speed" },
    { number: "80%", label: "Query Automation Rate" },
    { number: "4.8/5", label: "Customer Satisfaction" },
  ],
  problems: [
    {
      title: "Customer Onboarding Friction",
      desc: "Complex, manual onboarding processes frustrate customers and increase drop-off rates significantly.",
    },
    {
      title: "Lead Nurturing at Scale",
      desc: "Financial advisors can't effectively nurture hundreds of prospects simultaneously across channels.",
    },
    {
      title: "Support Cost Escalation",
      desc: "Growing customer base drives support costs up with repetitive queries consuming agent time.",
    },
    {
      title: "Customer Retention Challenges",
      desc: "Lack of proactive engagement leads to silent churn and customers switching to competitors.",
    },
  ],
  solutions: [
    {
      title: "AI Financial Advisors",
      desc: "Intelligent AI advisors that guide customers through product selection, onboarding, and queries 24/7.",
    },
    {
      title: "AI Customer Support Agents",
      desc: "Automated support that handles 80% of queries instantly, escalating only complex cases to humans.",
    },
    {
      title: "Financial Workflow Automation",
      desc: "End-to-end automation of KYC, document collection, verification, and compliance workflows.",
    },
    {
      title: "Client Engagement Platforms",
      desc: "Proactive engagement systems that check in with clients, share insights, and prevent silent churn.",
    },
  ],
  outcome:
    "Reduce customer support costs by 45% while improving satisfaction scores. Automate 80% of routine queries, speed up onboarding by 2x, and build a proactive engagement system that increases retention and wallet share.",
};

const FinancialPage = () => <IndustryPageTemplate data={financialData} />;

export default FinancialPage;
